export const TransactionStatusEnum = Object.freeze({
  PROCESSING: "PROCESSING",
  READY: "READY",
  PAID: "PAID",
});

export const TransactionStatusMeta = {
  [TransactionStatusEnum.PROCESSING]: { label: "Processing", badgeClass: "bg-warning text-dark" },
  [TransactionStatusEnum.READY]:      { label: "Ready",      badgeClass: "bg-info text-dark" },
  [TransactionStatusEnum.PAID]:       { label: "Paid",       badgeClass: "bg-success" },
};

export const normalizeStatus = (s) =>
  typeof s === "string" ? s.toUpperCase() : s;
